import { useEffect, useState } from "react"
import { Results } from "../../components"
import { TResult, results2021, results2022, results2023, results2024Z, results2024P, cyphers2021, cyphers2022, cyphers2023, cyphers2024Z, cyphers2024P, results2025Z, results2025P, cyphers2025P, cyphers2025Z, cyphers2026P, cyphers2026Z, results2026P, results2026Z } from "../../resources"
import './history.scss'
import { TCypher, EPage, Section, Select, Cypher, CypherRating, Cyphers, Heading } from '@sifrovacihra/shared-ui';
import { actualYear, changePage, gameCathegoryByYear, gameIdByYear, previousYears } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useAppState } from "../../store";



export const History = () => {
    
    const [year, setYear] = useState(actualYear.id)
    const [results, setResults] = useState(Array<TResult>)
    const [cyphers, setCyphers] = useState(Array<TCypher>)
    const { state } = useAppState()

    const navigate = useNavigate()

    useEffect(() => {
        switch (year) {
            case previousYears[0].id:
                setResults(results2021)
                setCyphers(cyphers2021)
                break
            case previousYears[1].id:
                setResults(results2022)
                setCyphers(cyphers2022)
                break
            case previousYears[2].id:
                setResults(results2023)
                setCyphers(cyphers2023)
                break
            case previousYears[3].id:
                setResults(results2024Z)
                setCyphers(cyphers2024Z)
                break
            case previousYears[4].id:
                setResults(results2024P)
                setCyphers(cyphers2024P)
                break
            case previousYears[5].id:
                setResults(results2025Z)
                setCyphers(cyphers2025Z)
                break
            case previousYears[6].id:
                setResults(results2025P)
                setCyphers(cyphers2025P)
                break
            case previousYears[7].id:
                setResults(results2026Z)
                setCyphers(cyphers2026Z)
                break
            case previousYears[8].id:
                setResults(results2026P)
                setCyphers(cyphers2026P)
                break
        }
    }, [year])

    function route() {
        switch (year) {
            case previousYears[0].id:
                return route2021()

            case previousYears[1].id:
                return route2022()

            case previousYears[2].id:
                return route2023()

            case previousYears[3].id:
                return route2024Z()

            case previousYears[4].id:
                return route2024P()

            case previousYears[5].id:
                return route2025Z()

            case previousYears[6].id:
                return route2025P()

            case previousYears[7].id:
                return route2026Z()

            case previousYears[8].id:
                return route2026P()

            default: return (<></>)
        }
    }

    function resultsText() {
        switch (year) {
            case previousYears[2].id:
            case previousYears[3].id:
            case previousYears[4].id:
            case previousYears[5].id:
            case previousYears[6].id:
                return resultsText2023()

            default: return (<></>)
        }
    }


    function fotogalery() {
        switch (year) {
            case previousYears[0].id:
                return fotogalery2021()

            case previousYears[1].id:
                return fotogalery2022()

            case previousYears[2].id:
                return fotogalery2023()

            case previousYears[3].id:
            case previousYears[4].id:
                return fotogalery2024()

            case previousYears[5].id:
            case previousYears[6].id:
                return fotogalery2025()

            case previousYears[7].id:
            case previousYears[8].id:
                return fotogalery2026()

            default: return (<></>)
        }
    }

    function resultsText2023() {
        return (
            <p>
                Podrobné statistiky průchodu najdete na stránce <span onClick={() => changePage(EPage.STATS, navigate)} className='href'>Statistiky</span>.
            </p>
        )
    }

    function route2021() {
        return (
            <p>
                Hra začínala i končila v Klubovce knihovny a vedla po stanovištích v bezprostředím okolí. Více si o jednotlivých stanovištích můžete přečíst v <a href='https://www.sifrovacihra.cz/sift/2021/trasa2021.png' target='_blank' rel="noreferrer">tomto letáčku</a>.
            </p>
        )
    }

    function route2022() {
        return (
            <p>
                Hra začínala na Náměstí T. G. Masaryka, vedla kolem historického centra města a končila v Klubovce knihovny. Tématem trasy byla voda a místa v Táboře s ní spojená. Více si o jednotlivých stanovištích můžete přečíst v <a href='https://www.sifrovacihra.cz/sift/2022/trasa2022_1.png' target='_blank' rel="noreferrer">tomto</a> a <a href='/sift/2022/trasa2022_2.png' target='_blank'>tomto</a> letáčku.
            </p>
        )
    }
    function route2023() {
        return (
            <p>
                Hra začínala na Náměstí T. G. Masaryka, vedla kolem historického centra města a končila v Klubovce knihovny. Tématem trasy byly historické táborské památky spojené s průmyslem. Více si o jednotlivých stanovištích můžete přečíst v <a href='https://www.sifrovacihra.cz/sift/2023/trasa2023.pdf' target='_blank' rel="noreferrer">tomto</a> letáčku.
            </p>
        )
    }
    function route2024Z() {
        return (
            <p>
                Kvůli rekonstrukci náměstí hra začínala v Botanické zahradě. Po vyluštění startovních šifřiček a první šifry sešly týmy k řece a vydali se směrem na jih.  Na konci města překonaly řeku a přes Babinu a Čelkovice se vrátily zpět do centra města. Letos hra končila v budově bývalé pošty, kde našla knihovna na následující 2 roky útočiště během rekonstukce hlavní budovy.
            </p>
        )
    }
    function route2024P() {
        return (
            <p>
                Kvůli rekonstrukci náměstí hra začínala v Botanické zahradě. Po vyluštění startovních šifřiček a první šifry sešly týmy k řece a vydali se směrem na jih.  Na konci města překonaly řeku a přes Babinu, Čelkovice a vyhlídku u Švehlova mostu se vrátily zpět do centra města. Letos hra končila v budově bývalé pošty, kde našla knihovna na následující 2 roky útočiště během rekonstukce hlavní budovy.
            </p>
        )
    }

function route2025Z() {
    return (
        <p>
            5. ročník ŠifTu začal před knihovnou na Pražském sídlišti. V parku Na Popravišti si týmy mohly vezvydnout chybějící dílky k 1. šifře a pak se vydat přes sídliště na kótu na Chlumu. Zde se Začátečníci oddělili od Pokročilých a pokračovali rovnou na křížovou cestu v Klokotech a následně přes Bílý altán do cíle v knihovně na Žižkově náměstí.
        </p>
    )
}
function route2025P() {
    return (
        <p>
            5. ročník ŠifTu začal před knihovnou na Pražském sídlišti. V parku Na Popravišti si týmy mohly vezvydnout chybějící dílky k 1. šifře a pak se vydat přes sídliště na kótu na Chlumu. Zde trasa svedla Pokročilé z prudkého kopce k lávce přes Lužnici u Harachovky. Následovalo stanoviště v Modrém lomu a kopec nahoru na křížovou cestu v Klokotech. Poslední stanoviště bylov  Bílém altánu a cíl, stejně jako loni, v knihovně na Žižkově náměstí.
        </p>
    )
}

    function route2026Z() {
        return (
            <p>
                6. ročník ŠifTu začal na dopravním hřišti u Jordánu. Z něj se týmy vypravili do Čekanic a následně zpátky k Jordánu - ke skále Rytíř. Pak trasa vedla zpět do města, nejprve do botanické zahrady a následně do cíle v knihovně na Žižkově náměstí.
            </p>
        )
    }
    function route2026P() {
        return (
            <p>
                6. ročník ŠifTu začal na dopravním hřišti u Jordánu. Z něj se týmy vypravili do Čekanic a následně zpátky k Jordánu - ke skále Rytíř. Pak trasa vedla zpět do města, týmy navštívily botanickou zahradu a pak kolem Jordánu a bašty Velký Šanc došly do cíle v knihovně na Žižkově náměstí.
            </p>
        )
    }


    function fotogalery2021() {
        return (
            <p>
                Fotky ze hry jsou dostupné na <a href='https://www.knihovnatabor.cz/taborska-sifrovacka' target='_blank' rel="noreferrer">této stránce</a>.
            </p>
        )
    }

    function fotogalery2022() {
        return (
            <p>
                Fotky ze hry jsou dostupné na <a href='https://www.knihovnatabor.cz/taborska-sifrovacka-2022' target='_blank' rel="noreferrer">této stránce</a>.
            </p>
        )
    }

    function fotogalery2023() {
        return (
            <p>
                Fotky ze hry jsou dostupné na <a href='https://www.knihovnatabor.cz/taborska-sifrovacka-2023' target='_blank' rel="noreferrer">této stránce</a>.
            </p>
        )
    }

    function fotogalery2024() {
        return (
            <p>
                Fotky ze hry jsou dostupné na <a href='https://photos.app.goo.gl/vujsvUnQ3W5E6kzRA' target='_blank' rel="noreferrer">této stránce</a>.
            </p>
        )
    }

    function fotogalery2025() {
        return (
            <p>
                Shrnutí hry a fotografie jsou v <a href=' https://www.knihovnatabor.cz/sift-sifrovaci-hra-v-ulicich-tabora-2025' target='_blank' rel="noreferrer">tomto článku</a>.
            </p>
        )
    }

    function fotogalery2026() {
        return (
            <p>
                Shrnutí hry a fotografie jsou v <a href='https://www.knihovnatabor.cz/sift-2026-tabor-zaplnily-sifry-i-nadseni-hraci' target='_blank' rel="noreferrer">tomto článku</a>.
            </p>
        )
    }
    
    return (
        <>
            <Heading headline="Minulé ročníky" weight={1} />
            <Section centered={true }>
                <Select options={previousYears.map(y => ({ key: y.id, label: y.value }))} value={year} label="Zvolte ročník" onChange={setYear} />
            </Section>
            <Section delimeter={true }>
                <Heading headline="Výsledková listina" weight={2} />
                <Results results={results} />
                {resultsText() }
            </Section>
            {cyphers.length> 0 ?
                <Section>
                    <Heading headline="Šifry" weight={2} />
                    <Cyphers cyphers={cyphers} renderCypher={c => (
                        <Cypher
                            cypher={c}
                            game={gameIdByYear(year)}
                            forumKey={`${gameCathegoryByYear(year) ?? ''}${c.Id}`}
                            token={state?.token}
                            ratingSlot={c.stars
                                ? <CypherRating cypherId={c.Id} stars={c.stars} votes={c.votes} interactive={false} />
                                : undefined}
                        />
                    )} />
                </Section>
                : <></>
            }
            <Section>
                <Heading headline="Trasa hry" weight={2} />
                <>
                    {route()}
                </>
                
            </Section>
            <Section>
                <Heading headline="Fotogalerie" weight={2} />
                <>
                    {fotogalery() }
                </>
            </Section>
            
        </>
        
        )
}
